import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=4b99ca96&scoped=true&lang=pug&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"
import style0 from "./Orders.scss?vue&type=style&index=0&id=4b99ca96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b99ca96",
  null
  
)

export default component.exports